import { actionsGeneratorV2 } from '@docavenue/core';

const synchronizeSSOProfileAction = actionsGeneratorV2({
  resource: 'ssoSynchronizeSSO',
  chunkUrlResource: 'sso/synchronize-sso',
});

export default synchronizeSSOProfileAction;
